import { render, staticRenderFns } from "./vRuta.vue?vue&type=template&id=2ca8e7a8&scoped=true&"
import script from "./vRuta.vue?vue&type=script&lang=js&"
export * from "./vRuta.vue?vue&type=script&lang=js&"
import style0 from "./vRuta.vue?vue&type=style&index=0&id=2ca8e7a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca8e7a8",
  null
  
)

export default component.exports